/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef, useEffect } from "react";
import crypto from "../../Crypto";
import { ModeloPost, ModeloUpdate } from "../../ModeloCrud";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useFormik } from "formik";
import {
  Grid,
  Container,
  Box,
  Divider,
  Autocomplete,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import TextField from "@mui/material/TextField";
import CustomModal from "../../../components/modals/CustomModal";
import SaveCancelButtons from "../../SaveCancelButtons";
import { CapSentence, CapSentenceArray } from "../../utils/Utils";

const validationSchema = yup.object({
  codigo: yup.object().required("Seleccione un Código"),
  caras: yup
    .string()
    .nullable(true)
    .matches(/[o,m,d,p,v,l,g,i,O,M,D,P,V,L,G,I]+/gi, "Cara(s) Inválida(s).")
    .max(5, "Máximo 5 Caracteres."),
});

export default function ModalInsertarEditarPrestacion({
  row,
  showModal,
  hideModal,
  setUpdateOk,
  turnoRow,
  onUpdateRow,
  onAddRow,
}) {
  const [modalMessage, setModalMessage] = useState(null);

  const Today = new Date();
  const [myloading, setMyLoading] = React.useState(false);
  const [errorSave, setErrorSave] = useState(null);
  const [modalInformationOpen, setModalInformationOpen] = useState(false);
  const piezasDentales = crypto.decryptDataStorage("piezas_dentales");
  const nomencladores = CapSentenceArray(
    crypto.decryptDataStorage("nomencladores"),
    ["codigo_descripcion"]
  );

  const handleClose = () => {
    codigoInicialSeteado.current = false;
    piezaInicialSeteada.current = false;
    hideModal();
  };
  const formik = useFormik({
    initialValues: {
      codigo: null,
      pieza: null,
      caras: row?.caras ?? "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("Valores del formulario:", values);
      let seguir = true;
      if (values.codigo.requiere_pieza === 1) {
        if (values.pieza === null) {
          formik.setFieldError("pieza", "El còdigo requiere pieza.");
          seguir = false;
        }
      }
      if (values.codigo.requiere_cara === 1) {
        if (values.caras === null || values.caras.trim() === "") {
          formik.setFieldError("caras", "El còdigo requiere cara(s).");
          seguir = false;
        }
      }
      if (seguir) {
        grabar(values, row ? "UPDATE" : "INSERT");
      }
    },
    enableReinitialize: true, // Reinitialize form values when row changes
  });

  const piezaInputRef = useRef(null);
  const carasInputRef = useRef(null);

  const codigoInicialSeteado = useRef(false);
  const piezaInicialSeteada = useRef(false);

  useEffect(() => {
    if (
      showModal &&
      !codigoInicialSeteado.current &&
      row?.nomenclador_id &&
      nomencladores.length
    ) {
      const codigo_encontrado = nomencladores.find(
        (n) => n.nomenclador_id === row.nomenclador_id
      );
      if (codigo_encontrado) {
        formik.setFieldValue("codigo", codigo_encontrado);
        codigoInicialSeteado.current = true;
      }
    }

    if (
      showModal &&
      !piezaInicialSeteada.current &&
      row?.diente &&
      piezasDentales.length
    ) {
      const diente_encontrado = piezasDentales.find(
        (p) => p.diente === row.diente
      );
      if (diente_encontrado) {
        formik.setFieldValue("pieza", diente_encontrado);
        piezaInicialSeteada.current = true;
      }
    }
  }, [
    showModal,
    row?.nomenclador_id,
    row?.diente,
    nomencladores,
    piezasDentales,
  ]);

  const onCodigoChange = (event, values) => {
    if (!values) {
      formik.setFieldValue("pieza", null);
      formik.setFieldValue("caras", "");
    }
    formik.setFieldValue("codigo", values);
  };
  const onPiezaChange = (event, values) => {
    formik.setFieldValue("pieza", values);
  };

  const handleKeyDownCodigo = (event) => {
    if (event.key === "Enter") {
      // Simulate tab key press
      event.preventDefault(); // Prevent form submission
      if (piezaInputRef.current) {
        piezaInputRef.current.focus();
      }
    }
  };

  const handleKeyDownPieza = (event) => {
    if (event.key === "Enter") {
      // Simulate tab key press
      event.preventDefault(); // Prevent form submission

      if (carasInputRef.current) {
        carasInputRef.current.focus();
      }
    }
  };

  const handleKeyDownTextField = (event) => {
    if (event.key === "Enter") {
      // Simulate tab key press
      var form = event.target.form;
      var index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 2].focus();
      event.preventDefault();
    }
  };

  async function grabar(values, operacion) {
    setMyLoading(true);
    setErrorSave(null);
    const Today = new Date();
    const userid = crypto.decryptLocalStorage("user_id");
    const Data = {
      nomenclador_id: values.codigo.nomenclador_id,
      pieza_dental_id: values.pieza ? values.pieza.id : null,
      caras: values.caras ? values.caras.toUpperCase() : "",
      ...(operacion === "INSERT" && {
        turno_id: turnoRow ? turnoRow.turno : null,
        user_id_carga: userid,
        fecha_carga: Today.toISOString().split("T")[0], // "2025-05-26"
        hora_carga: Today.toTimeString().split(" ")[0], // "14:32:45"
      }),
    };

    if (operacion === "UPDATE") {
      let result = await ModeloUpdate(
        "tratamiento",
        turnoRow.tratamiento_id,
        Data
      );
      setMyLoading(false);
      if (result.error === false) {
        const data = result.listado[0];
        const filaActualizada = {
          tratamiento_id: data.id,
          nomenclador_id: data.nomenclador_id,
          diente: values.pieza?.diente ?? null,
          caras: data.caras,
          codigo: data.codigo_nomenclador,
          descripcion: data.descripcion_nomenclador,
          capitulo: data.codigo_nomenclador?.substring(0, 2) ?? "",
        };
        onUpdateRow(filaActualizada);
        handleClose();
      } else {
        setMyLoading(false);
        setModalMessage(result.errormessage);
        setModalInformationOpen(true);
      }
    } else {
      let result = await ModeloPost("tratamiento", null, null, Data);
      setMyLoading(false);
      if (result.error === false) {
        const data = result.listado[0];
        const nuevaFila = {
          ...turnoRow, // copia base
          tratamiento_id: data.id,
          nomenclador_id: data.nomenclador_id,
          diente: values.pieza?.diente ?? null,
          caras: data.caras,
          codigo: data.codigo_nomenclador,
          descripcion: data.descripcion_nomenclador,
          capitulo: data.codigo_nomenclador?.substring(0, 2) ?? "",
          debitos: null,
          debitos_descrip: null,
          debitos_id: null,
          detalle_rechazo: null,
          id_refacturacion: null,
          periodo_refacturacion: null,
          resultado_auditoria: null,
          valor: 0,
        };
        onAddRow(nuevaFila, turnoRow.tratamiento_id); // ✅ le pasás también el tratamiento base
        hideModal();
      } else {
        setMyLoading(false);
        setModalMessage(result.errormessage);
        setModalInformationOpen(true);
      }
    }
  }

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      title={row !== null ? "Editar prestación" : "Insertar prestación"}
      disableActions
      maxWidth="sm"
      icon={
        row !== null ? (
          <EditIcon fontSize="medium" sx={{ color: "white" }} />
        ) : (
          <AddIcon fontSize="medium" sx={{ color: "white" }} />
        )
      }
    >
      <Container maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {turnoRow && turnoRow.nombre_paciente && (
                <Typography variant="body1">
                  Paciente:
                  {CapSentence(turnoRow.nombre_paciente.toLowerCase())}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: 1,
              }}
            >
              <Autocomplete
                id="codigo"
                options={nomencladores}
                value={formik.values.codigo}
                autoHighlight
                size="small"
                onChange={onCodigoChange}
                getOptionLabel={(option) =>
                  CapSentence(option.codigo_descripcion.replace(/:/g, ""))
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onKeyDown={handleKeyDownCodigo}
                    label="Código"
                    error={
                      formik.touched.codigo && Boolean(formik.errors.codigo)
                    }
                    helperText={formik.touched.codigo && formik.errors.codigo}
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      style: { justifyContent: "center" },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: 1,
              }}
            >
              <Autocomplete
                id="pieza"
                options={piezasDentales}
                value={formik.values.pieza}
                autoHighlight
                size="small"
                onChange={onPiezaChange}
                getOptionLabel={(option) => option.diente}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    inputRef={(el) => (piezaInputRef.current = el)} // Callback ref to assign the input element
                    {...params}
                    onKeyDown={handleKeyDownPieza}
                    label="Pieza"
                    error={formik.touched.pieza && Boolean(formik.errors.pieza)}
                    helperText={formik.touched.pieza && formik.errors.pieza}
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      style: { justifyContent: "center" },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={(el) => (carasInputRef.current = el)} // Callback ref to assign the input element
                id="caras"
                label="Caras"
                onKeyDown={handleKeyDownTextField}
                value={formik.values.caras}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={formik.touched.caras ? formik.errors.caras : ""}
                error={formik.touched.caras && Boolean(formik.errors.caras)}
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 3 }} />
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <SaveCancelButtons
              handleCancel={handleClose}
              loading={myloading}
              isModal={true}
            />
          </Box>
        </form>
      </Container>
    </CustomModal>
  );
}
